module.exports = __webpack_public_path__ + "img/banner-12-4@2x.698c8c9a.jpg";